module.exports = __webpack_public_path__ + "img/cycle_blue.108dde24.svg";